import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';
import theme from '../../utils/theme';
import PostCard from '../../components/post/PostCard';
import { PostType } from '../../types/types';
import { RootState } from '../../store';
import { Link } from 'react-router-dom';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

const TrendingJobs: React.FC = () => {
  const { data } = useSelector((state: RootState) => state.frontViewData);
  const [posts, setPosts] = useState<PostType[]>([]);

  useEffect(() => {
    if (data && data.data) {
      const fetchedData = data.data;
      const postData = fetchedData?.posts;
      setPosts(postData || []);
    }
  }, [data]);

  return (
    <Box sx={{ width: '100%', px: { xs: 1, lg: 10 , xl: 20 }, pb: 5 }}>
      <Box sx={{ mt: 8, mb: 3 }}>
        <Typography sx={{ fontSize: '22px', display: 'inline', fontStyle: 'italic' }}>Today</Typography>
        <Typography
          sx={{
            fontSize: '22px',
            display: 'inline',
            fontStyle: 'italic',
            color: theme.palette.primary.main,
            fontFamily: 'Racing Sans One',
            letterSpacing: '1px',
            ml: 1,
          }}
        >
          trending jobs
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {posts.length > 0 &&
          posts.map((post: PostType, index: number) => (
            <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
              <PostCard index={index} post={post} />
            </Grid>
          ))}
      </Grid>
      <Box sx={{ maxWidth: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 5, mx: 'auto' }}>
        <Link to={'jobs'}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
            <Typography
              sx={{ color: theme.palette.primary.main, mr: 2, display: 'inline' }}
            >Explore More
            </Typography>
            <DoubleArrowIcon sx={{ color: theme.palette.primary.main, display: 'inline' }}/>
          </Box>
        </Link>
      </Box>
    </Box>
  );
};

export default TrendingJobs;
